import netcoServer from '../../apis/netcoServer';
import {ADD_WORKFLOW_OPTIONS} from "../types";
import handleResponse from "../helpers/handleResponse";
import loadingCall from "../helpers/loadingCall";

const saveWorkflowOption= (formValues, callback) => async (dispatch) => {
  let response = await loadingCall(dispatch, () => netcoServer.newPost('/UserService/addWorkflowOption', formValues));
  handleResponse(dispatch, response, ADD_WORKFLOW_OPTIONS, onSuccessPayload,null,[],[callback]);

};

const onSuccessPayload = data => {
  return {
    workflowList: {
      workflowOptions: data.result.workflowOptions
    }
  };
};
export default saveWorkflowOption;